import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface InfoTileProps {
  label: ReactNode;
  value?: ReactNode;
  children?: ReactNode;
  className?: string;
  valueClassName?: string;
}

export function InfoTile({ label, value, children, className, valueClassName }: InfoTileProps) {
  return (
    <div className={cn("rounded-2xl border bg-background p-3", className)}>
      <div className="text-xs text-muted-foreground">{label}</div>
      {value !== undefined ? (
        <div className={cn("mt-1 text-sm", valueClassName)}>{value}</div>
      ) : null}
      {children}
    </div>
  );
}
